//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  mounted() {
    // 获取本地存储的数据(find查询结果)
    let t = this,
      find = JSON.parse(sessionStorage.getItem('find'))
    console.log(find)
    t.fileListL = find
    t.manufactureDateTime = t.fileListL.manufactureDate.split(' ')[0]
    t.lastTestDateTime = t.fileListL.lastTestDate.split(' ')[0]
    // 转成字符串
    let str = t.fileListL.experiamentDate + ''
    if (t.fileListL.experiamentDate) {
      t.experiamentDateTime = str.split(' ')[0]
      console.log(t.experiamentDateTime)
    }
    // t.fillingtimes = t.fileListL.fillingtime.split(" ")[0];
    if (t.fileListL.fillingtime) {
      t.fillingtimes = t.fileListL.fillingtime.split(' ')[0]
    }
    // t.valveMakeDateTime = t.fileListL.valveMakeDate.split(" ")[0];
    if (t.fileListL.valveMakeDate) {
      t.valveMakeDateTime = t.fileListL.valveMakeDate.split(' ')[0]
    }

    // 工作压力
    t.workingPressureP = parseInt(t.fileListL.workingPressure)

    // 充装前重量
    t.originalTareWeightP = parseInt(t.fileListL.originalTareWeight)
  },
  data() {
    return {
      fileListL: {},
      manufactureDateTime: '',
      lastTestDateTime: '',
      fillingtimes: '',
      valveMakeDateTime: '',
      experiamentDateTime: '',
      workingPressureP: '',
      originalTareWeightP: ''
    }
  },
  methods: {
    goon() {
      //   this.$router.push({
      //     path: "/certificateFind"
      //   });
      this.$router.push('/certificateFind')
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/find/certificateResult1.vue